<template>
  <div v-if="to && from" class="p-h-give-point-page-icon">
    <div class="p-h-give-point-page-icon__inner">
      <div class="p-h-give-point-page-icon__to">
        <IconUserImage :size="recipientIconSize">
          <img :src="to" alt />
        </IconUserImage>
      </div>
      <!-- <div class="p-h-give-point-page-icon__from">
        <IconUserImage :size="senderIconSize">
          <img :src="from" alt />
        </IconUserImage>
      </div> -->
      <!-- <div class="p-h-give-point-page-icon__arrow">
        <IconBase
          :width="arrowSize.width"
          :height="arrowSize.height"
          view-box="0 0 37 25"
          icon-color="transparent"
        >
          <IconArrowRight3sticksType2
            :icon-color="arrowIconColor"
            border-color="#ffffff"
          />
        </IconBase>
      </div> -->
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowRight3sticksType2 from "@/common/components/icons/IconArrowRight3sticksType2.vue";

import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";

@Options({
  props:{
    to: { type: [String, Boolean], default: false },
    from: { type: [String, Boolean], default: false }
  },
  components: {
    IconUserImage,
    IconBase,
    IconArrowRight3sticksType2
  }
})
export default class HDeliveryDetails extends Vue {
  to!: string | boolean;
  from!: string | boolean;

  get isSpScreenWidth() {
    return globals?.isSpScreenWidth;
  }

  get arrowIconColor() {
    return commons?.colorCode;
  }

  get recipientIconSize() {
    return this.isSpScreenWidth ? 74 : 135;
  }

  get senderIconSize() {
    return this.isSpScreenWidth ? 36 : 64;
  }

  get arrowSize() {
    return this.isSpScreenWidth
      ? {
          width: 18,
          height: 12
        }
      : {
          width: 34,
          height: 22
        };
  }
}
</script>

<style lang="scss" scoped>
.p-h-give-point-page-icon {
  &__inner {
    @include pc {
      width: rem(148);
      display: flex;
      justify-content: flex-end;
    }
    @include sp {
      padding-left: rem(12);
    }
    position: relative;
  }

  &__to {
    @include pc {
      width: rem(135);
      height: rem(135);
    }
    @include sp {
      width: rem(74);
      height: rem(74);
    }
    position: relative;
  }

  &__from {
    @include pc {
      width: rem(70);
      height: rem(70);
    }
    @include sp {
      width: rem(40);
      height: rem(40);
    }
    border-radius: 50%;
    border: px(2) solid #ffffff;
    display: block;
    position: absolute;
    bottom: rem(-2);
    left: 0;
  }

  &__arrow {
    @include pc {
      width: rem(34);
      height: rem(22);
      left: rem(44);
      bottom: rem(-2);
    }
    @include sp {
      width: rem(18);
      height: rem(12);
      left: rem(28);
      bottom: rem(2);
    }
    display: block;
    position: absolute;
  }
}
</style>
